// /eventos
export const permissionsKeys = {
  page: 'event-schema.find',
  pageBlockFind: 'event-schema.find',
  pageBlockCreate: 'event-schema.create',
  pageBlockUpdate: 'event-schema.update',
  pageBlockRemove: 'event-schema.remove',
  pageBlockShareWithDependencies: 'event-schema.update',
  pageBlockShareWithUsers: 'event-schema.update',
};
